import { Box, CircularProgress, Typography } from '@mui/material';
import { motion } from 'framer-motion';

interface PageLoaderProps {
  message?: string;
  fullHeight?: boolean;
}

export function PageLoader({ message, fullHeight = true }: PageLoaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: fullHeight ? '100vh' : '50vh',
      }}
    >
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, ease: 'easeOut' }}
        style={{ textAlign: 'center' }}
      >
        <CircularProgress color="primary" />
        {message && (
          <Typography color="text.secondary" sx={{ mt: 2 }}>
            {message}
          </Typography>
        )}
      </motion.div>
    </Box>
  );
}
